<template>
  <div style="height: 78vh; overflow-y: scroll">
    <div v-if="is_create">
      <div class="mt-2">
        <a href="javascript:void(0)" @click="is_create = false"
          ><i class="fa fa-arrow-left" style="cursor: pointer;"></i> Back</a
        >
      </div>
      <create-event></create-event>
    </div>
    <div v-else-if="full_event_details">
      <div class="mt-2">
        <a href="javascript:void(0)" @click="full_event_details = false"
          ><i class="fa fa-arrow-left" style="cursor: pointer;"></i> Back</a
        >
      </div>
      <fullEventDetails v-bind:event="event_id"></fullEventDetails>
    </div>
    <div v-else>
      <div class="mt-3 mb-4">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 col-md-9">
                <h3 class="pt-2 mb-0">
                  <b>{{ org_details.org_name }}</b>
                </h3>
              </div>
              <div class="col-12 col-md-3">
                <button
                  class="btn btn-primary float-right btn-block"
                  @click="is_create = true"
                >
                  Create Schedule Event
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-12 col-sm-6 col-md-3 mt-2 mb-2">
          <div
            class="card text-white"
            style="height: 80px; border-radius: 12px;"
          >
            <div class="container-fluid">
              <div class="row">
                <div
                  class="col-4 text-center"
                  style="height: 80px; border-radius: 12px 0 0 12px;background: #636363;"
                >
                  <p style="position: relative;top: 30%;">
                    <b>{{ org_details.total_events }}</b>
                  </p>
                </div>
                <div class="col-8">
                  <p style="position: relative;top: 30%;">Total Events</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-3 mt-2 mb-2">
          <div
            class="card text-white"
            style="height: 80px; border-radius: 12px;"
          >
            <div class="container-fluid">
              <div class="row">
                <div
                  class="col-4 text-center"
                  style="height: 80px; border-radius: 12px 0 0 12px;background: #636363;"
                >
                  <p style="position: relative;top: 30%;">
                    <b>{{ org_details.total_attendees }}</b>
                  </p>
                </div>
                <div class="col-8">
                  <p style="position: relative;top: 25%;">Total Attendees</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-3 mt-2 mb-2">
          <div
            class="card text-white"
            style="height: 80px; border-radius: 12px;"
          >
            <div class="container-fluid">
              <div class="row">
                <div
                  class="col-4 text-center"
                  style="height: 80px; border-radius: 12px 0 0 12px;background: #636363;"
                >
                  <p style="position: relative;top: 30%;">
                    <b>{{ org_details.total_sessions }}</b>
                  </p>
                </div>
                <div class="col-8">
                  <p style="position: relative;top: 30%;">Total Sessions</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-3 mt-2 mb-2">
          <div
            class="card text-white"
            style="height: 80px; border-radius: 12px;"
          >
            <div class="container-fluid">
              <div class="row">
                <div
                  class="col-4 text-center"
                  style="background: #636363;height: 80px; border-radius: 12px 0 0 12px;"
                >
                  <p style="position: relative;top: 30%;">
                    <b>{{ org_details.total_members }}</b>
                  </p>
                </div>
                <div class="col-8">
                  <p style="position: relative;top: 30%;">Team Members</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 mb-4" v-if="events.length > 0">
        <h5><b>All Events</b></h5>
        <table class="table  text-dark">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Event Name</th>
              <th>Start at</th>
              <th>ATT</th>
              <th>SPK</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(e, i) in events" :key="i">
              <td>{{ i + 1 }}</td>
              <td>{{ e["title"] }}</td>
              <td>{{ e["start_date"] }} {{ e["start_time"] }}</td>
              <td>{{ e["registered_user"] }}</td>
              <td>{{ e["speaker_count"] }}</td>
              <td>
                <!-- <router-link
                  :to="'/e/' + e['event_id']"
                  class="btn btn-primary btn-sm"
                  >Manage <i class="fa fa-edit"></i
                ></router-link> -->
                <button @click="showEventDetails(e['event_id'])" class="btn btn-primary btn-sm">
                  Manage <i class="fa fa-edit"></i>
                </button>
                <a
                  href="javascript:void(0)"
                  class="btn btn-danger btn-sm ml-1"
                  data-toggle="modal"
                  data-target="#deleteDialog"
                  @click="delete_event = e"
                  ><i class="fa fa-trash"></i
                ></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="margin: 10%;" v-else>
        <div class="text-center">
          <svg
            width="250"
            height="250"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <image
              href="../../assets/balloon.svg"
              style="color: #fbaf28 !important;"
              width="250"
              height="250"
            />
          </svg>
          <p>
            Saved event will show up here, <br />
            so you can view them here later.
          </p>
          <button class="btn btn-outline-primary" @click="is_create = true">
            Create Event
          </button>
        </div>
      </div>
      <div class="mt-3 mb-4"></div>
    </div>
    <!-- Modal -->
    <div
      class="modal"
      id="deleteDialog"
      tabindex="-1"
      role="dialog"
      aria-labelledby="deleteDialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body text-center">
            <h1><i class="fas fa-question"></i></h1>
            <p style="margin-bottom: 2px;"><b>Are your sure?</b></p>
            <p>This action will delete all details</p>
            <button
              type="button"
              class="btn btn-danger"
              @click="deleteEventFunction()"
            >
              Yes, delete it.
            </button>
            <button
              type="button"
              class="ml-2 btn btn-primary"
              id="close-deleteDialog"
              data-dismiss="modal"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import createEvent from "@/components/dashboard/create-event.vue";
import fullEventDetails from "@/components/dashboard/full-event-details.vue";

export default {
  name: "dashboard",
  data() {
    return {
      user: { is_admin: false },
      upcomingEvents: [],
      teams: [],
      events: [],
      registered_user_count: 0,
      org_details: {
        is_active: "",
        org_email: "",
        org_id: "",
        org_logo: "",
        org_name: "",
        role: "",
        total_attendees: 0,
        total_events: 0,
        total_members: 0,
        total_sessions: 0,
      },
      is_create: false,
      full_event_details: false,
      event_id: "",
      delete_event: {},
    //   headers: [
    //     {
    //       text: "S.No",
    //       align: "start",
    //       sortable: false,
    //       value: "name",
    //     },
    //     {
    //       text: "Event name",
    //       value: "event_name",
    //     },
    //     {
    //       text: "Start At",
    //       value: "start_at",
    //     },
    //     {
    //       text: "ATT",
    //       value: "attendees",
    //     },
    //     {
    //       text: "SPK",
    //       value: "speakers",
    //     },
    //     {
    //       text: "Actions",
    //       value: "name",
    //     },
    //   ],
    };
  },
  components: {
    createEvent,
    fullEventDetails
  },
  mounted() {
    this.getDetails();
    // this.teamMembers()
    this.eventList();
    this.$root.$on("createEvent", () => {
      this.is_create = true;
    });
    this.$root.$on("eventSuccess", () => {
      this.eventList();
      this.is_create = false;
    });
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user_info"));
    if (this.user === null) {
      this.$router.push("/");
    }
  },
  methods: {
    showEventDetails(id) {
      this.event_id =  id;
      this.full_event_details = true;
    },
    getDetails: function() {
      this.$store
        .dispatch("getOrgDetails", this.$route.params.id)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.org_details = resp.data.data;
          }
        });
    },
    deleteEventFunction: function() {
      // console.log(this.delete_event)
      this.$store
        .dispatch("deleteEvent", this.delete_event.event_id)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.delete_event = {};
            document.getElementById("close-deleteDialog").click();
            this.getDetails();
            this.eventList();
          }
        });
    },
    eventList: function() {
      this.$store.dispatch("getEvents", this.$route.params.id).then((resp) => {
        if (resp.data.status === "success") {
          this.events = resp.data.data;
          this.registered_user_count = resp.data.registered_user_count;
        }
      });
    },
  },
};
</script>
